import React, { Component } from 'react';
import { Container, Row, Col, Input, Button, Alert } from 'reactstrap';
import { Link } from 'react-router-dom';
import AuthFunctions from '../services/AuthService';
import AdminFunctions from '../admin/AdminFunctions';
import Session from '../auth/Session';
import moment from "moment";

//Comp Types currently:
//1 - Office Lease
//2 - Office Sale
//3 - Ind. Lease
//4 - Ind. Sale
//5 - Retail Lease
//6 - Land Sale
//7 - Multi Family


export class CompsIndex extends Component {
    static displayName = CompsIndex.name;

    constructor(props) {
        super(props);
        this.state = {
            
        }

        this.checkAuthenticated();
    }

    hideField(fieldName) {
        var compArray = this.state.fieldCompTypes.find(w => w.fieldName === fieldName);
        if (compArray) {
            var found = compArray.validComp.includes(this.state.compType);
            return !found;
        } else {
            return true;
        }
        
    }
    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        var isAdmin = false;
        var isComps = false;
        if (isAuthenticated) {
            isAdmin = await AdminFunctions.isAdminAsync();
            isComps = await AdminFunctions.isRole("Comps");
            if (!isComps) {
                this.props.history.push('/login');
            }
        }
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
    }

    async componentDidMount() {
        var _token = Session.getToken();
    }

    render() {
        return (
            <div className="pageDiv">

            </div>
        );
    }


}
